/**
 * Marken-Marker: das Logo der Kette statt des Einkaufswagens.
 *
 * Schlüssel ist die Wikidata-ID der Marke (`Supermarket.brandWikidata`, aus dem OSM-Tag
 * `brand:wikidata`), nicht `brand` — dort stehen „Edeka" und „EDEKA" nebeneinander, die ID ist
 * für beide Q701755. Herkunft und Lizenz jedes Logos: `brands/README.md`. Dieselbe Liste führt
 * tri-server in `src/rendering/mapMarkerIcons.ts` (`BRAND_MARKERS`).
 */
import Q701755 from './brands/Q701755.svg';
import Q879858 from './brands/Q879858.svg';
import Q16968817 from './brands/Q16968817.svg';
import Q151954 from './brands/Q151954.svg';
import Q41171373 from './brands/Q41171373.svg';
import Q284688 from './brands/Q284688.svg';
import Q41171672 from './brands/Q41171672.svg';
import Q450180 from './brands/Q450180.svg';
import Q685967 from './brands/Q685967.svg';
import Q57515238 from './brands/Q57515238.svg';
import Q48883773 from './brands/Q48883773.svg';
import Q552652 from './brands/Q552652.svg';
import Q1547993 from './brands/Q1547993.svg';
import Q1113618 from './brands/Q1113618.svg';
import Q1718009 from './brands/Q1718009.svg';
import Q327854 from './brands/Q327854.svg';
import Q876811 from './brands/Q876811.svg';
import Q15836148 from './brands/Q15836148.svg';
import Q1533254 from './brands/Q1533254.svg';
import Q1022827 from './brands/Q1022827.svg';
import Q2536857 from './brands/Q2536857.svg';
import Q457503 from './brands/Q457503.svg';
import Q864179 from './brands/Q864179.svg';
import Q794939 from './brands/Q794939.svg';
import Q830334 from './brands/Q830334.svg';
import Q1709809 from './brands/Q1709809.svg';
import Q920166 from './brands/Q920166.svg';
import Q391080 from './brands/Q391080.svg';
import Q2108626 from './brands/Q2108626.svg';
import Q1458135 from './brands/Q1458135.svg';
import Q5880423 from './brands/Q5880423.svg';
import Q23903628 from './brands/Q23903628.svg';
import Q1819101 from './brands/Q1819101.svg';
import Q1700015 from './brands/Q1700015.svg';
import Q73642490 from './brands/Q73642490.svg';
import Q116486979 from './brands/Q116486979.svg';
import Q3147425 from './brands/Q3147425.svg';
import Q2717882 from './brands/Q2717882.svg';
import Q131384218 from './brands/Q131384218.svg';
import Q70287020 from './brands/Q70287020.svg';
import Q829459 from './brands/Q829459.svg';
import Q420545 from './brands/Q420545.svg';
import Q5646230 from './brands/Q5646230.svg';
import Q1899368 from './brands/Q1899368.svg';
import Q7281341 from './brands/Q7281341.svg';
import Q1604631 from './brands/Q1604631.svg';
import Q3918608 from './brands/Q3918608.svg';
import Q1053170 from './brands/Q1053170.svg';
import Q598884 from './brands/Q598884.svg';
import Q1425063 from './brands/Q1425063.svg';
import Q42773330 from './brands/Q42773330.svg';
import Q2523363 from './brands/Q2523363.svg';
import Q15890910 from './brands/Q15890910.svg';
import Q60711675 from './brands/Q60711675.svg';
import Q1439966 from './brands/Q1439966.svg';
import Q1502859 from './brands/Q1502859.svg';
import Q634831 from './brands/Q634831.svg';
import Q129391 from './brands/Q129391.svg';
import Q2823880 from './brands/Q2823880.svg';
import Q691162 from './brands/Q691162.svg';
import Q1969162 from './brands/Q1969162.svg';
import Q5911596 from './brands/Q5911596.svg';
import Q8040120 from './brands/Q8040120.svg';
import Q261077 from './brands/Q261077.svg';
import Q7315394 from './brands/Q7315394.svg';
import Q1162859 from './brands/Q1162859.svg';
import Q1815030 from './brands/Q1815030.svg';
import Q2746220 from './brands/Q2746220.svg';
import Q671990 from './brands/Q671990.svg';
import Q1751979 from './brands/Q1751979.svg';
import Q2143252 from './brands/Q2143252.svg';
import Q4734166 from './brands/Q4734166.svg';
import Q111372965 from './brands/Q111372965.svg';
import Q749431 from './brands/Q749431.svg';
import Q3410757 from './brands/Q3410757.svg';
import Q212599 from './brands/Q212599.svg';
import Q65455969 from './brands/Q65455969.svg';
import Q5653536 from './brands/Q5653536.svg';
import Q855525 from './brands/Q855525.svg';
import Q24906315 from './brands/Q24906315.svg';

export const BRAND_MARKERS: Record<string, string> = {
    Q701755, // EDEKA
    Q879858, // Netto Marken-Discount
    Q16968817, // REWE
    Q151954, // Lidl
    Q41171373, // Aldi Nord
    Q284688, // Penny
    Q41171672, // Aldi Süd
    Q450180, // Norma
    Q685967, // Kaufland
    Q57515238, // Nahkauf
    Q48883773, // Denns BioMarkt
    Q552652, // Netto
    Q1547993, // Tegut…
    Q1113618, // Combi (Einkaufsmarkt)
    Q1718009, // K+K Klaas & Kock
    Q327854, // Mix Markt
    Q876811, // Alnatura
    Q15836148, // NP-Markt
    Q1533254, // Marktkauf Holding
    Q1022827, // CAP
    Q2536857, // Wasgau
    Q457503, // Globus Holding
    Q864179, // Bio Company
    // Hotels
    Q794939, // B&B Hotels
    Q830334, // Best Western Hotels & Resorts
    Q1709809, // Mercure
    Q920166, // Ibis
    Q391080, // Motel One
    Q2108626, // Premier Inn
    Q1458135, // Ibis Budget
    Q5880423, // Holiday Inn Express
    Q23903628, // H-Hotels
    Q1819101, // Leonardo Hotels
    Q1700015, // Dorint
    Q73642490, // IntercityHotel
    Q116486979, // the niu
    Q3147425, // Ibis Styles
    Q2717882, // Holiday Inn
    Q131384218, // ACHAT Hotels
    Q70287020, // Moxy Hotels
    Q829459, // Steigenberger
    Q420545, // Novotel
    Q5646230, // Hampton by Hilton
    Q1899368, // Maritim
    Q7281341, // Radisson Blu
    Q1604631, // NH Hotel Group
    Q3918608, // Marriott Hotels & Resorts
    Q1053170, // Courtyard by Marriott
    Q598884, // Hilton Hotels
    Q1425063, // Hyatt
    Q42773330, // Meininger Hotel Gruppe
    Q2523363, // Vienna International Hotelmanagement
    Q15890910, // a&o Hostels
    Q60711675, // Park Inn by Radisson
    Q1439966, // Four Points by Sheraton
    Q1502859, // Ramada Worldwide
    Q634831, // Sheraton
    Q129391, // Scandic Hotels
    Q2823880, // Adagio City Aparthotel
    Q691162, // Mövenpick
    Q1969162, // Westin Hotels & Resorts
    Q5911596, // Hotel Indigo
    Q8040120, // Wyndham Hotels & Resorts
    Q261077, // Le Méridien
    Q7315394, // Residence Inn by Marriott
    Q1162859, // Hilton Garden Inn
    Q1815030, // Meliá Hotels International
    Q2746220, // Crowne Plaza
    Q671990, // Kempinski
    Q1751979, // Radisson Hotel
    Q2143252, // Renaissance Hotels
    Q4734166, // Aloft Hotels
    Q111372965, // Serways
    Q749431, // Sofitel
    Q3410757, // Pullman Hotels and Resorts
    Q212599, // Accor
    Q65455969, // Dormero Hotels
    Q5653536, // AC Hotels
    Q855525, // Conrad Hotels
    Q24906315, // OYO Rooms
};

/** Das Logo zur Marke, oder `undefined` — dann gilt das Icon des Typs. */
export const brandMarkerUrl = (brand: unknown): string | undefined =>
    brand ? BRAND_MARKERS[String(brand)] : undefined;
